// Custom JS - theme.js

const ThemeManager = {

  // Selettore per <html>
  html: document.querySelector("html"),

  // Funzione per applicare il tema "light" o "dark"
  applyTheme(theme) {
    // 1. Imposta il color-scheme su <html> (come da tuo codice)
    this.html.style.setProperty("color-scheme", theme);

    // 2. Salva il tema nella localStorage
    localStorage.setItem("theme", theme);

    // 3. Imposta l'attributo data-theme su <body>
    document.body.setAttribute("data-theme", theme);
  },

  // Funzione per determinare il tema attuale
  getCurrentTheme() {
    return this.html.style.getPropertyValue("color-scheme").trim();
  },

  // Funzione per inizializzare il tema
  initializeTheme() {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      // Se c’è un tema salvato in localStorage, usalo
      this.applyTheme(savedTheme);
    } else {
      // Altrimenti, controlla le preferenze di sistema
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      this.applyTheme(prefersDark ? "dark" : "light");
    }
  },

  // Funzione per alternare il tema
  toggleTheme() {
    const currentTheme = this.getCurrentTheme();
    const newTheme = currentTheme === "dark" ? "light" : "dark";
    this.applyTheme(newTheme);
  },

  // Aggiungi un event listener per il pulsante toggle
  attachToggleListener(toggleSelector) {
    const toggleElement = document.querySelector(toggleSelector);
    if (toggleElement) {
      toggleElement.addEventListener("click", () => this.toggleTheme());
    } else {
      console.warn(`Elemento "${toggleSelector}" non trovato.`);
    }
  },

  // Aggiungi l'event listener per i cambiamenti del sistema operativo
  watchSystemPreferences() {
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (event) => {
        const systemPrefersDark = event.matches;
        // Cambia automaticamente solo se l'utente non ha scelto manualmente un tema
        if (!localStorage.getItem("theme")) {
          this.applyTheme(systemPrefersDark ? "dark" : "light");
        }
      });
  },
};

export default ThemeManager;
